import { firePricingEventToSite } from '@ff-os/pdp-shared-redux/global-state/site-events';
import { observeStore } from '@ff-os/pdp-shared-redux/observeStore';
import { PhotoPrintsPdpStore } from '@ff-scene-plugins/photo-prints-redux/store';
import { selectTotalRequest } from '../../_redux-groups';

export const firePricingEventOnChange = (store: PhotoPrintsPdpStore) => {
    observeStore(store, selectTotalRequest, firePricingEventToSite);
};